import {motivateAccountingVars as vars} from '../../../constants/vuexVariables'
const state = {
  [vars.listWorkersOnWork]: []
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/motivateAccounting/state.js